module.exports = __webpack_public_path__ + "static/media/6013edd1.jpg";